export const Constants = {
    BANNER_HEADING: 'Compare and Configure: Precision Quotes at a Glance',
    BANNER_PARAGRAPH: 'Leverage our CPQ for swift quote comparisons and informed decision-making. Start now.',
    BREADCRUMB_NAME: "Visualization",
    COMPAREQUOTEBUTTONTXT: "+ Add & Compare Quote",
    SEARCHPLACEHOLDER: "Search...",
    NODATAHEADING: "Compare Quotes",
    NODATAPARAGRAPH: "Please include additional quotes for comparison with the current one.",
    CURRENTQUOTEHEADING: "Current (If applicable)",
    BNDLEQUOTESERRORNOTIFICATION: "Bundling is not allowed since pricing structure is different for different quotes",
    BNDLEQUOTESCRNCYERRORNOTIFICATION: "Bundling is not allowed since Requested currency is different for different quotes",
    BUNDLEDRATES: "Bundled Rates",
    APPROVE: "Approve",
    REJECT: "Reject",
    BUNDLE: "Bundle",
    QUOTES: "Quoted",
    CURRENT: "Current",
    ACTION: "Actions",
    SEARCH: "Search Notes",
    TOTALREVENUE: "Total revenue - incl. commission:",
    TOTALREVENUEUSD: "USD Total revenue - incl. commission:",
    ANNUALREVENUE: "Annual revenue for WPO - w/o commission:",
    ANNUALREVENUEUSD: "USD Annual revenue for WPO - w/o commission:",
    TOCRTBNDL: "To create a bundle ",
    BUNDLESUBMITINFOTEXTSTART: "Click on ",
    PLSSLMORE: "please select more than ",
    ONEQT: "one quote",
    BUNDLEINFOTEXT: ". You can create up to a maximum of three bundles. After clicking the bundle button, it will be displayed above the quotes section.",
    BUNDLESUBMITINFOTEXTEND: " to submit the bundle for approval.",
    BUNDLEAPPROVETINFOTEXTEND: " to approve the bundle.",
    VIEW: "View",
    CONFIRM: "Confirm",
    OK: "Ok",
    REFRESH: "Refresh",
    NOTESTITLE: "Notes",
    NOTEBANNER: "Add Note",
    NOTEHEADING: "Note",
    REFRESHMESSAGE: "Page Refreshed Successfully",
    NOCURRENTTEXT: " (This section is only applicable to renewal Opportunities)",
    BUNDLEERRORMESSAGE: "Maximum number of bundles reached. Please remove a bundle before adding a new one",
    BUNDLESELECTMOREERROR: "Select more than one quote to create a bundle",
    NOBUNDLETEXT1: "To view bundle rates,",
    NOBUNDLETEXT2: " please create bundles from the quotes section provided below.",
    CURRENTNODATATEXT: "No data available",
    QUOTEDNODATATEXT: "Quotes are not available for the selected opportunity",
    FETCHINGDATA: "Fetching data. Please wait...",
    ADDDISCOUNT: "Discount / Rate increase",
    ADDDISCOUNTVALUEDESCRIPTION: "(+/-)discount value to this bundle",
    BUTTONDISCOUNTNAMEPERCENT: "Switch to Percent",
    ADDDISCOUNTDESCRIPTION: "(+/-)discount percent to this bundle",
    TOOLTIP_PROMPTDUPLICATEBUNDLE: "Discount will be applied over Rate(in Requested Currency).",
    BUTTONDISCOUNTNAMEVALUE: "Switch to Value",
    BUTTONDISCOUNTPREVIEW: "Preview Discount",
    BUTTONSAVEBUNDLE: "Save",
    BUTTONAPPROVEBUNDLE: "Approve Bundle",
    BUTTONAPPROVEINPROGRESSBUNDLE: "Approving..",
    BUTTONSUBMITBUNDLE: "Submit",
    PLACEHOLDERTEXTDISCOUNTPERCENT: "Discount by percent",
    PLACEHOLDERTEXTDISCOUNTAMOUNT: "Discount by amount",
    VALIDATIONERROR_DISCOUNTINVALIDINPUT: "Please enter a valid number",
    VALIDATIONERROR_DISCOUNTLESSTHANHUNDRED: "Discount cannot be less than -100(%)",
    VALIDATIONERROR_DISCOUNTLESSTHANTOTALAMOUNT: "Discount cannot be less than total amount",
    MESSAGE_BUNDLEREMOVESUCCESS: "Bundle was removed successfully!",
    MESSAGE_BUNDLEADDTOCRMUCCESS: "Bundle was added to CRM successfully!",
    MESSAGE_BUNDLEAPPROVED: "Bundle approved! Bundle details will be written to CRM shortly.",
    MESSAGE_SOMETHINGWENTWRONG: "Something went wrong! please try again or contact administrator",
    MESSAGE_SOMETHINGWENTWRONG_DUPLICATE: "Something went wrong while duplicating quotes, please try again!",
    MESSAGE_SOMETHINGWENTWRONG_GETBUNDLEUPLOADDATA: "Something went wrong while fetching bundle data!",
    MESSAGE_SOMETHINGWENTWRONG_ADDBUNDLETOCRM: "Something went wrong while adding bundle to CRM! Please retry or contact administrator",
    MESSAGE_DISCOUNTEMPTY: "Please provide a valid discount value for preview!",    
    MESSAGE_BUNDLESUBMITTED: "Bundle submitted succesfully!",    
    MESSAGE_BUNDLESUBMITTED_TOPRICINGTEAM: "Bundle submitted for Pricing Team approval!",    
    MESSAGE_BUNDLESUBMITTEDERROR: "Error occured: Bundle was not submitted. Please try again after sometime!",    
    MESSAGE_BUNDLEAPPROVEDERROR: "Error occured: Bundle was not approved. Please try again after sometime!",
    MESSAGE_SAVEUPDATEBUNDLENAMESUCCESS: "Bundle name updated successfully.",
    MESSAGE_SAVEUPDATEBUNDLENAMEERROR: "Something went wrong! Bundle name was not updated.",
    DIALOG_MESSAGE_CONFIRMREMOVEBUNDLE: "Are you sure you want to remove the bundle?",    
    DIALOG_MESSAGE_PROMPTDUPLICATEBUNDLE: "Duplicates will be created for the approved quotes in the bundle to move forward.",    
    QUOTEDISABLEDCHECKBOX: "Quote with status {STATUS} cannot be bundled",    
};

export const DISCOUNTMODE = {
    PERCENT: 0,
    VALUE: 1
};

export const BUNDLEVALIDATIONSTATUS = {
    VALIDATION_SUCCESS_APPROVE: { Code: 1, Message: "Bundle approved successfully, you will be notified when it syncs with CRM" },
    VALIDATION_FAILURE_QUOTES_MODIFIED_AFTER_BUNDLE: { Code: 2, Message: "Some quotes were modified after bundling, please refresh the bundle" },
    VALIDATION_FAILURE_QUOTES_SAVED_AS_DRAFT: { Code: 3, Message: "Some quote(s) in the bundle are Saved as Draft" },
    VALIDATION_FAILURE_QUOTES_PENDING_PRICING_TEAM: { Code: 4, Message: "Some quote(s) in the bundle are Pending with Pricing Team" },
    VALIDATION_FAILURE_QUOTES_PENDING_INITIAL_REQUESTOR: { Code: 5, Message: "Some quote(s) in the bundle are Pending with Initial Requestor" },
    VALIDATION_FAILURE_QUOTES_ALREADY_APPROVED: { Code: 6, Message: "Some quote(s) in the bundle are already approved" }
};

export const BUNDLESTATUS = {
    BUNDLECREATED: 1,
    BUNDLESUBMITTED: 2,
    DISCOUNTSAVED: 3,
    BUNDLEAPPROVED: 4,
    BUNDLEREMOVED: 5,
    BUNDLEREJECTED: 6
};

export const BundleOpportunityDetailsConstants =
{    
    OPPORTUNITYNAME: "Opportunity Name",
    OPPORTUNITYID: "Opportunity ID",
    OPPORTUNITYTYPE: "Pricing Type",
    ACCOUNTMANAGER: "Account Manager",
    PARTNERRESELLER: "Partner / ReSellers",    
    BROKER: "Broker/Consultant",
    COMMISSION: "Broker Commission",
    ACSUBTYPE: "Account Sub-Type"
}

export const BundleNotesHeader = [
    "No.",
    "Created By",
    "Date",
    "Time",
    "Message",
];

export const DialogConstants = {
    CONFIRM: 0,
    APPROVE: 1,
    NOTE: 2,
    REJECT: 3,
};